import '../styles/Dashboard.css';

const DashboardPage = () => {
  return (
    <div className="dashboard-container">
      <img src="/assets/budaya-ksn.png" className="budaya-ksn-image" alt="Budaya KSN"/>
    </div>
  );
};

export default DashboardPage;
